import { render, staticRenderFns } from "./AuthorisationsTable.vue?vue&type=template&id=6263eb00&scoped=true&"
import script from "./AuthorisationsTable.vue?vue&type=script&lang=js&"
export * from "./AuthorisationsTable.vue?vue&type=script&lang=js&"
import style0 from "./AuthorisationsTable.vue?vue&type=style&index=0&id=6263eb00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6263eb00",
  null
  
)

export default component.exports